import { render, staticRenderFns } from "./stripe-connect-options-form.vue?vue&type=template&id=1382d688&scoped=true&"
import script from "./stripe-connect-options-form.vue?vue&type=script&lang=ts&"
export * from "./stripe-connect-options-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1382d688",
  null
  
)

export default component.exports